import { render, staticRenderFns } from "./dropdown-v2.vue?vue&type=template&id=b668ad32&scoped=true&"
import script from "./dropdown-v2.vue?vue&type=script&lang=js&"
export * from "./dropdown-v2.vue?vue&type=script&lang=js&"
import style0 from "./dropdown-v2.vue?vue&type=style&index=0&id=b668ad32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b668ad32",
  null
  
)

export default component.exports